import { ChatsTypes } from '../constants/chatConstants';

const addMessage = (message) => ({
    type: ChatsTypes.CHAT_NEW_MESSAGE,
    message, 
});

const typingMessage = (data) => ({
    type: ChatsTypes.CHAT_TYPING_MESSAGE,
    user: data.user, 
});

const stopTypingMessage = (user) => ({
    type: ChatsTypes.CHAT_STOPTYPING_MESSAGE,
    user, 
});

export default {
    addMessage,
    typingMessage,
    stopTypingMessage
};